export enum Align {
  LEFT = 'left',
  CENTER = 'center',
  RIGHT = 'right'
}

export enum TableDataType {
  HTML = 'html',
  DYNAMIC_COMPONENT = 'dynamic_component',
  TEMPLATE= 'template'
}

export enum DateFormat {
  TIME = 'HH:mm',
  DATE = 'DD.MM.yyyy',
  UTC_DATE = 'YYYY-MM-DD',
  DATE_TIME = 'dd.MM.yyyy HH:mm'
}

export enum TextFormat {
  DAY = 'day',
  TIME = 'time',
  DECIMAL = 'decimal',
  DATE_TIME_ZONE = 'timezone'
}

export enum TableEvent {
  RIGHT_CLICK_CELL,
  TOGGLE_EXPANDED,
  UPDATE_MAXLEVEL
}

export enum FormControlType {
  INPUT = 'input',
  TEXTAREA = 'textarea',
  SELECT = 'select',
  AUTOCOMPLETE = 'autocomplete',
  CHECKBOX = 'checkbox',
  RADIO = 'radio',
  DATEPICKER = 'datepicker',
  FILE = 'file',
  DYNAMIC_COMPONENT = 'dynamic_component',
  SWITCH = 'switch',
  TEXT = 'text',
  RADIO_SQUARE = 'radio_square',
  INPUT_INLINE = 'input_inline',
  DROPDOWN_SELECTOR_INPUT = 'dropdown_selector_input',
  SELECT_IMAGE = 'select_image'
}

export enum FilterType {
  TEXT = 'text',
  DATE = 'date',
  NUMBER = 'number',
  RESET = 'reset-all' // reset all column filter
}

export enum SCREEN_SIZE {
  // Extra small is none
  SMALL = 'sm',
  MEDIUM = 'md',
  LARGE = 'lg',
  EXTRA_LARGE = 'xl'
}

export enum DIRECTION {
  HORIZONTAL = 'horizontal',
  VERTICAL = 'vertical',
  INSITE = 'insite'
}

export type AuthScreenState = 'login' | 'register' | 'change-password';

export enum ChangePasswordState {
  INIT,
  TOKEN_EXPIRED,
  TOKEN_VERIFIED,
  COMPLETE
}

export enum RequestRoleStatus {
  DEFAULT = 'default',
  REQUESTED = 'requested',
  COMPLETE = 'complete'
}

export enum SSO {
  MICROSOFT = 'microsoft',
  GOOGLE = 'google',
  IDPORTEN = 'id-porten',
  VERIFY_IDPORTEN = 'verify-id-porten'
}

export enum SELECT_TYPE {
  FILE = 'file',
  IMAGE = 'image'
}


export enum ACTIVATE_STATUS {
  NotActivated = 'NotActivated',
  Expired = 'Expired',
  Activated = 'Activated'
}


export enum VALIDATE_IMAGE {
  MAX_FILE_SIZE = 2 * 1024 * 1024, // 2MB
  MIN_DIMENSION = 150, // 150x150 pixels
  MAX_DIMENSION = 1000 // 1000x1000 pixels
}

export enum DEED_STATUS {
  FILLING_IN_PROGRESS = 1,
  READY_TO_SIGN = 2,
  SENT_FOR_SIGNATURE = 3,
  READY_TO_SUBMITTED = 4,
  SUBMITTED = 5,
  ARCHIVE = 7,
  DELETED = 8
}

export enum CONTRACT_TYPE {
  SALE = 1,
  LEASE_TRANSFER = 2,
  LEASE_TRANSFER_WITH_PROPERTY = 3
}

export enum DataFetchState {
  LOADING = 'loading',
  SUCCESS = 'success',
  EMPTY = 'empty',
  ERROR = 'error'
}

export enum ControlResult {
  NotApproved = 'IKKE_GODKJENT',
  Unclear = 'UAVKLART',
}

export enum MESSAGE_ICONS {
  ERROR = 'warning',
  WARNING = 'warning_amber',
  SUCCESS = 'check_circle',
  DEFAULT = 'info'
}

export type MessageType = 'error' | 'warning' | 'success';

export enum DocumentType {
  Unsigned = 0,
  Signed = 1
}

export enum XMLType {
  Validate = 0,
  Submit = 1
}
